/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 09:57:11
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-14 13:48:55
 */
import { HttpService } from '@package/service'
import { serviceConfig } from '../utils/httpConfig.js'

const Http = new HttpService(serviceConfig)
export { Http }
